// @core/api/endpoints/workflow/get_pipeline_run_as_eligibility.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetPipelineRunAsEligibilityRequest,
  GetPipelineRunAsEligibilityResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Check how an actor can be assigned to a pipeline
 * Retrieves pipeline run as eligibility by the specified identifier.
 */
export async function GetPipelineRunAsEligibility(
  pipeline_id: string,
  data: GetPipelineRunAsEligibilityRequest,
  options?: RequestOptions
): Promise<GetPipelineRunAsEligibilityResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/pipelines/:pipeline_id/run-as/eligibility`;
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.post<GetPipelineRunAsEligibilityResponse>(requestPath, data, requestOptions);
}
